import _ from 'lodash'

const titleCase = (str) => _.startCase(_.camelCase(str))

export default titleCase